import {
  API_SHOP_LIST,
  API_UPDATE_FAVOR_SHOP,
  API_VISIT_HISTORY_AND_UPDATE,
  API_SHOP_COUPON_LIST,
} from '@utils/api.js'
import popup from '@utils/popup.js'
import $ from '@utils/axios.js'

export const state = {
  shop: {
    barcode: {
      //ポップアップの最大数を拡張（広域ページ移行STEP2）
      //バーコード形式（ポップアップの表示方法）にIDとパスワード、PDF、電話番号を追加（広域ページ移行）
      0:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      1:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      2:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      3:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      4:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      5:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      },
      6:{
        'BUTTON_TITLE'     :'', // ボタンタイトル
        'CODE_SHOW_FLAG'   :'', // コード提示フラグ
        'CODE_IMG_PATH'    :'', // コード表示画像
        'CODE_FORMAT'      :'', // コード形式
        'CODE'             :'', // コード文字列
        'CODE_ID'          :'', // ID
        'CODE_PW'          :'', // パスワード
        'CODE_TEL'         :'', // 電話番号
        'LINK_BUTTON_TITLE':'', // リンクボタンタイトル
        'LINK_URL'         :'', // リンクURL
      }
    }
  },
  isClipped: false,
  coupons: [],
}

export const mutations = {
  updateShop: (state, newVal) => {
    state.shop = newVal
  },
  clearShop: (state) => {
    state.shop = null
  },
  updateClipFavor: (state, newVal) => {
    state.isClipped = newVal
  },
  SET_COUPONS(state, newValue) {
    state.coupons = newValue
  },
}

export const actions = {
  // 施設詳細店舗データ
  updateShop: ({ commit, rootState }, payload) => {
    const params = {}
    params.session_id = rootState.auth.sessionId
    params.TYPE = '2'
    params.FACILITIES_ID = payload.FACILITIES_ID
    if(!rootState.auth.loggedIn) {
      params.NO_LOGIN_FLAG = '1'
    }else{
      params.NO_LOGIN_FLAG = '0'
    }
    if (payload.SEARCH_ID) params.SEARCH_ID = payload.SEARCH_ID
    if (payload.PREVIEW) params.PREVIEW = payload.PREVIEW
    if (payload.COUPON_NO) params.COUPON_NO = payload.COUPON_NO

    var formData = new FormData();
    for (var k in params) {
      formData.append(k, params[k] ?? "");
    }

    $.post(API_SHOP_LIST, formData)
      .then((response) => {
        const shop = response.data && response.data.shop
        commit('updateShop', shop)
        commit('updateClipFavor', shop.FAVO_FLAG)
      })
      .catch((e) => {})
  },
  // お気に入り施設登録・解除
  updateClipFavor: ({ commit, rootState }, payload) => {
    const params = {}
    params.session_id = rootState.auth.sessionId
    params.FACILITIES_ID = payload.FACILITIES_ID
    params.DELETED = payload.DELETED
    if (payload.DELETED === '1') {
      window.dataLayer.push({
        event: '優待のクリップ解除',
        event_action: payload.FACILITIES_ID + '_' + payload.MEISYO,
        event_category: '優待クリップ解除',
        ap_screen_name: '優待_施設詳細',
        ap_facility_id: payload.SHISETU_ID,
        ap_facility_name: payload.MEISYO,

        ap_member_id: payload.memberNo,
        ap_member_type: localStorage.getItem('userType'),
      })
    } else {
      window.dataLayer.push({
        event: '優待のクリップ',
        event_action: payload.FACILITIES_ID + '_' + payload.MEISYO,
        event_category: '優待クリップ',
        ap_screen_name: '優待_施設詳細',
        ap_facility_id: payload.SHISETU_ID,
        ap_facility_name: payload.MEISYO,

        ap_member_id: payload.memberNo,
        ap_member_type: localStorage.getItem('userType'),
      })
    }
    if (rootState.coupons.preview !== '') {
      commit('updateClipFavor', payload.DELETED === '1' ? '0' : '1')
      popup({
        text:
          payload.DELETED === '1'
            ? 'お気に入りを解除しました。'
            : 'お気に入りに登録しました。',
      })
    } else {
      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      $.post(API_UPDATE_FAVOR_SHOP, formData)
        .then(() => {
          commit('updateClipFavor', payload.DELETED === '1' ? '0' : '1')
          popup({
            text:
              payload.DELETED === '1'
                ? 'お気に入りを解除しました。'
                : 'お気に入りに登録しました。',
          })
        })
        .catch((e) => {})
    }
  },
  // 訪問履歴取得および更新
  registerHumonnRireki: ({ commit, rootState }, payload) => {
    const params = {}
    params.session_id = rootState.auth.sessionId
    params.TYPE = '1'
    params.FACILITIES_ID = payload.FACILITIES_ID
    params.FACILITIES_ID = payload.FACILITIES_ID
    params.B_LONGITUDE = payload.B_LONGITUDE || '0.0'
    params.B_LATITUDE = payload.B_LATITUDE || '0.0'

    var formData = new FormData();
    for (var k in params) {
      if (k === "customConfig") { continue; }
      formData.append(k, params[k] ?? "");
    }

    $.post(API_VISIT_HISTORY_AND_UPDATE, formData)
      .then((response) => {
        if (response.data.status_code === '00') {
          console.log('Registerd visit history')
          window.location.href = 'applink://membercard'
        }
        // if (response.data.status_code !== '00') {
        //   throw new Error(response.data.error_code)
        // }
      })
      .catch((e) => {})
  },
  async fetchCoupons({ commit, state, rootState }, id) {
    const params = {}
    params.FACILITIES_ID = id
    params.session_id = rootState.auth.sessionId
    params.customConfig = {
      withoutLoading: true,
    }

    try {
      var formData = new FormData();
      for (var k in params) {
        if (k === "customConfig") { continue; }
        formData.append(k, params[k] ?? "");
      }

      const response = await $.post(API_SHOP_COUPON_LIST, formData)
      // const response = await $.get(API_SHOP_COUPON_LIST, {
      //   params: params
      // })

      // const response = await axios.get(API_COUPON_LIST, {
      //   params: params,
      // })
      if (response.data.status_code !== '00') {
         throw new Error(response.data.error_code)
      }
      const coupons = Object.values(response.data.coupon)
      commit('SET_COUPONS', coupons)
      return coupons
    } catch (e) {
      throw e;
    }
  },
}
